import React from 'react';
import { ChatTeardropDots } from '@phosphor-icons/react';
import { track } from '@/lib/analytics';

const FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdS8t16IEN6VVi4uUHZjcf96fwk4j2_Ibw1AS6sMkdBEmW1wQ/viewform?usp=publish-editor';

const BetaFeedbackButton = ({ variant = 'outline', label = 'Beta Feedback', testid = 'beta-feedback-button', icon = true, source = 'unknown' }) => {
  const base = 'inline-flex items-center gap-2 transition-all text-sm font-medium';
  const variants = {
    outline: `${base} px-4 py-2 rounded-md border border-[#C5A059] text-[#0A1128] hover:bg-[#C5A059]/10`,
    sidebar: `${base} w-full px-3 py-2 text-[#C5A059] hover:bg-white/5 rounded-md border border-[#C5A059]/30`,
    primary: `${base} px-4 py-2 rounded-md bg-[#C5A059] text-[#0A1128] hover:bg-[#B08F4A]`,
  };
  return (
    <a
      href={FORM_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={variants[variant] || variants.outline}
      data-testid={testid}
      onClick={() => track('feedback_button_clicked', { source })}
    >
      {icon && <ChatTeardropDots size={16} weight="duotone" />}
      {label}
    </a>
  );
};

export default BetaFeedbackButton;
